export default __webpack_public_path__ + "static/media/Edit_Name_server_DoDaddy.c67691e2.webp";